import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 213,6 L 0,350 310,380" fill={colors.light} />
      <path d="M 213,6 L 310,380 399,296" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
